import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  content: {
    backgroundColor: '#fff',
    position: 'relative',
    maxWidth: '460px',
    padding: '15px',
    borderRadius: '8px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    padding: '44px 24px 24px 24px',
    gap: '19px',
  },
  closeIcon: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    cursor: 'pointer',
  },
  title: {
    fontWeight: 700,
    fontSize: '20px',
    textAlign: 'center',
  },
  subtitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '19px',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)',
    textAlign: 'center',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 15px',
    gap: '15px',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    fontWeight: 500,
  },
  footer: {
    display: 'flex',
    gap: '10px',
  },
  button: {
    textTransform: 'uppercase',
  },
  loader: {
    color: '#fff'
  }
}))
